var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "-webkit-fill-available",
      "display": "inline-flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "card-header-tab"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      attrs: {
        "title": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.value) + "\n    ")])
  })), _vm._v(" "), (_vm.pocAutoFlag) ? _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "type": "button",
      "title": "Auto Allocate Shipment"
    },
    on: {
      "click": _vm.autoAllocateShipment
    }
  }, [_vm._v("Auto Allocate Shipment  "), _c('i', {
    staticClass: "fa fa-cog"
  })])]) : _vm._e()]), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, _vm._g({
    key: _vm.componentKey,
    ref: "moveToNext",
    tag: "component",
    staticClass: "tab",
    attrs: {
      "VehicleCapacity": _vm.VehicleCapacity,
      "parentOBj": _vm.childOBj
    }
  }, _vm.$listeners))], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07ef5742","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/TripManagement/AddShipments/AddShipments.component.html
// module id = 1326
// module chunks = 3